export default __webpack_public_path__ + "static/media/step7-1.8f65f589.jpg";